<template>
  <i class="fa fa-circle" style="font-size: 7px;" :style="{ 'color': statusColor(type) }"></i>
</template>

<script>
export default {
  props: {
    type: [Number, String],
  },
  data() {
    return {
      value: this.type,
    };
  },
  methods: {
    statusColor(type) {
      switch (type) {
        case "fireBrick":
          return "#B22222";
        case "red":
          return "#FF0000";
        case "goldenrod":
          return "#FF8C00";
        case "olive":
          return "#808000";
        case "gold":
          return "#FFD700";
        case "green":
          return "#008000";
        case "forestGreen":
          return "#228B22";
        case "limeGreen":
          return "#00FF00";
        case "mediumBlue":
          return "#0000CD";
        case "brown":
          return "#A52A2A";
        case "greenYellow":
          return "#ADFF2F";
        case "coral":
          return "#FF7F50";
        case "salmon":
          return "#E9967A";
        case "indigo":
          return "#4B0082";
        case "lightblue":
          return "#6495ED";
        case "orange":
          return "#FFA500";
        case "darkred":
          return "#800000";
        case "mixred":
          return "#B3005E";
        default:
          return "#808080";
      }
    },
  },

  watch: {
    type() {
      this.value = this.type;
    },
  },
};
</script>

